import { ModalConstructor } from "../ModalConstructor";
import {
    ContentTypography,
    ServiceModalInnerContainerStyles,
} from "./ServiceModal.styles";
import { ModalContentBox } from "../MapModals.styles";
import { Typography } from "@mui/material";
import {
    isRunningInNativeAndriod,
    isRunningInNativeIOS,
} from "../../../../Infrastructure/Helpers/IsRunningInNativeApp";
import { useNativeApp } from "../../../../Infrastructure/Providers/NativeAppProvider";

export function LocationPermissionMissingModal({
    handleClose,
    isOpen,
}: {
    handleClose: () => void;
    isOpen: boolean;
}) {
    const { isPluginEnabled } = useNativeApp();

    let modalTextType = LOCATION_PERMISSIONS_TEXT_TYPES.BROWSER;

    if (!isPluginEnabled && isRunningInNativeAndriod()) {
        modalTextType = LOCATION_PERMISSIONS_TEXT_TYPES.ANDROID;
    } else if (!isPluginEnabled && isRunningInNativeIOS()) {
        modalTextType = LOCATION_PERMISSIONS_TEXT_TYPES.IOS;
    }

    const modalTitle = <Typography>{getModalTitle(modalTextType)}</Typography>;

    const modalContent = (
        <ModalContentBox>
            <ContentTypography>
                {getModalContent(modalTextType)}
            </ContentTypography>
        </ModalContentBox>
    );

    return (
        <ModalConstructor
            onClose={handleClose}
            open={isOpen}
            modalContent={modalContent}
            modalTitle={modalTitle}
            isBorderRadiusVisible={false}
            isInsideClosingButtonVisible={false}
            isOutsideClosingButtonVisible={true}
            modalInnerContainerStyles={ServiceModalInnerContainerStyles}
        />
    );
}

enum LOCATION_PERMISSIONS_TEXT_TYPES {
    "ANDROID",
    "IOS",
    "BROWSER",
}

function getModalContent(textType: LOCATION_PERMISSIONS_TEXT_TYPES) {
    switch (textType) {
        case LOCATION_PERMISSIONS_TEXT_TYPES.ANDROID:
            return "Um Zugriff zu erlauben, öffne auf deinem Android Gerät “App-Einstellungen” > “Berechtigungen”. Gib dort deinen Standort für die CHECK24 App frei und stelle sicher, dass die Standortübermittlung deines Gerätes aktiviert ist.";
        case LOCATION_PERMISSIONS_TEXT_TYPES.IOS:
            return "Um Zugriff zu erlauben, öffne auf deinem iOS Gerät “Einstellungen” > “Datenschutz & Sicherheit” > “Ortungsdienste”. Gibt dort deinen Standort für die CHECK24 App frei und stelle sicher, dass die Standortübermittlung deines Gerätes aktiviert ist.";
        default:
            return "In den Browser-Einstellungen kannst du eine Zugriffsberechtigung auf deinen Standort erteilen. Stelle zudem sicher, dass in deinen Systemeinstellungen die Standortfreigabe explizit für deinen aktuellen Browser aktiv ist.";
    }
}

function getModalTitle(textType: LOCATION_PERMISSIONS_TEXT_TYPES) {
    switch (textType) {
        case LOCATION_PERMISSIONS_TEXT_TYPES.ANDROID:
            return "Die CHECK24 App hat keinen Zugriff auf deinen Standort";
        case LOCATION_PERMISSIONS_TEXT_TYPES.IOS:
            return "Die CHECK24 App hat keinen Zugriff auf deinen Standort";
        default:
            return "Die Community Plattform hat keinen Zugriff auf deinen Standort";
    }
}
